export const defaultDatabase = [
  {
    label: 'alpha cleavage',
    rxnCode: 'eM``eIhOh`!fH@Oj@ eF``fJD#Qg Qp Qd#!RPNp@@qtJ_@ !RGUi| !R_P@]nop',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1149/1945-7111/abdde7',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMHJN`pksPqFdD@`!fI@GudYA@H@ eF@HhP#Q^ Qp Qd#!RWrL@@qvrO@ !RG]i| !R@@L]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Water elimination',
    rxnCode: 'eFH`fLGtX!fI@Gu` fHT`P#QX QP a`#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gCiALAJRu@_HYlgHE@!fI@Gu` eO``fNZ`~cIrE@#qNT qH Qg#!R@BL@[@@cGPj| !RG]i| !Rog~w?Qwzo@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMH`eIXOda`!fI@Gu` eF@bXhP#Qy Qp Qd#!R@Fp@XqtJ_@ !RG]i| !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGrDZHpypB@P!gCh@@eKHFLv\\@`D@ eF``fLGtX#qn\\J qfQ qk#!R|Gvw__A|_g?p_Qurw@ !R_wy||G}~GYk| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 23',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGrDZHpypB@P!gCh@@eKHFLv\\@`D@ eF``fLGtX#qbu_ qj{ Ql#!RlKvwo[@|og~poQurw@ !R_{x|lG~~GYk| !R@BL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 24',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGtDQas`D@`!gJT@AdijdCzZHpypB@P fHT`P#qbqo qJ|h Qp#!R|Gvw__A|_g?p_Qurw@ !Rb@KW@gx@bGt]vhH !RG_i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 25',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGtFQas`D@`!gChAAIRfdCF[N@PB@ eF`BLGtX#qj|^ qbs qo#!Rm?wp?[]|_g~w?QvRw@ !R@Fp?[@AcG]k| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 26',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'day@B@HIRigjf`Cy@`hcEYpB@P!gGTAAaJTwTpGrFZHpypB@P eF@HhP#IaLJfxP IaBia q~#!RbGwW_Wx@bOq~O}_|bGt]lcp !R|Gvw__A|_g?p_Qtzw@ !R@FL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 27',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Tropylium rearragement',
    rxnCode:
      'gOpAMJUKua@@Gtt@!gOpAGJTju`@@Gt\\@#qgVMX qYoTp#!Ri}w^@Hc]i?rg?Mx@GPhB !Rwg}GED]sw~g_~dvOG]h|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Tropylium fragmentation',
    rxnCode:
      'gOpAGJTju`@@D!gKPACJTnLE@P eF@HxP#qqUcx qMsx Qd#!RkpXxCLvpO`BblClLG[KB !RS|T~@BLXSzh]FhH !R@DL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'http://people.whitman.edu/~dunnivfm/C_MS_Ebook/CH6/6_9_5.html',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Tropylium fragmentation',
    rxnCode:
      'gFpAAJTjZ@@A@!gBPAAJTkRpD eF@HxP#qbqk qbu qY#!RdMvww]y?wg~wwQurW@ !R@M{^[}yoGUj| !R@@L]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'https://en.wikipedia.org/wiki/Fragmentation_%28mass_spectrometry%29',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphonates fragmentation',
    rxnCode:
      'gJPeE`DSpTiMMPGtT@!gC`eE`DSpdiLtA@ fH@Oj@#qbNh qbN qh#!Rb@I~Owx@bGt]|`H !Ru?sW_Wx@GQjB !RGWi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 60',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gGQeLZ@b^@eJZihCzB@!gJQdEb@b^BSTtA}A@ fHT`P#qbqk qbMX Qp#!ROvL@Xvp?OvMc@AtrO@ !RbOq~@Gx?bGt]v`H !RGWi|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 49',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gNqeLZ@b^@eJZZZ`OhH@!gJQeEb@b^@eIjZ@~`p eF@HhP#qbqkx qbMX q~#!ROvp@[FL?Ovql@@AcGSHB !RbOq~@Gx?bGt]N`H !R@FL]~kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 50',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gGQeLZ@b^@eJZihCzB@!gCaiHlO@SGZ@` eFB@HcA}D@#qbqk qQ] Ql#!ROvL@Xvp?OvMc@AwRO@ !Ruwu~@Ha}GUk| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 51',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gGQeEb@b^BeIiZhCzJ@!gC`eE`DSpdiLtA@ eFHBLGtP#qbqk qbM qs#!RXp@@[C}cXp@@XqtrP` !RbOq~@Ha}G]jB !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 45',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gNqeEb@b^BgHiDVj`Ohh@!gJQeEb@b^BeIij@~bp eF@HhP#qbqkx qbqh q_#!R[@@@Xs}l[@@@[@AcGPiB !RbOq~@Gx?bGt]N`H !R@FL]~kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 46',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'daxLRDp`BH|DgHiDbuU@GtI@!gGPdE`DSpRYvi@~d` eFH`fLGtX#IaLJfxP IaBka qs#!R[C|?XpAc[@@?[@Al@FL]lmp !RbOrH_Wx@b@JH_Qvz`` !R@FL]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 47',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gGQeEb@b^BeIiZhCzJ@!gC`eE`DSpdiLtA@ eFHBLGtP#qbqk qbM qs#!RXp@@[C}cXp@@XqtrP` !RbOq~@Ha}G]jB !R@FL]~gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 48',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gJYIC`DBTijXCzB@!eMhdiRVB eFB@HcA}D@#qbqh qJh Ql#!Rb@KW@gx@bGt]\\hH !R@Fp@XqwZ?@ !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 19',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gGYIC`DBTiff`OhH@!gCiIL`DBTff@~`p eF@HhP#IaLJa qbM IG@#!RupJH@m]}_`BH_Qtr`` !RbOq~@Ha}GSjB !R@FL]~kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 20',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gNyIC`DF\\dTJij@~a`!gJYHC`DISTpGtL@ eF@bXpP#IaLJnD qbqh IxP#!Rb@KW@gx@bGvH?Ha}GWJB !Rb@KW@gx@bGt]NhH !R@FL]Agp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 21',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gGYIC`DB\\dTMM@_PP!gCaHL@aJZPH eF``fJGtP#qbqo qbq qo#!R|Gvw_Wy?|Gsp_Qvrw@ !R@Fp?[@AcG]i| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 22',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sulfoxides fragmentation',
    rxnCode:
      'eMJhBBXvCyH\\@!fHT`P eFJHBHh_Q@#Qg Qp Qd#!ROvL@Xqwro@ !RGUi| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 65',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sulfones fragmentation',
    rxnCode:
      'gC`iH`DRXzpGrdZ@!fHT`P eMFI@bM`~f@#qbq qH Qm#!Re{v~@Hb}G[K| !RGYi| !RWrL@Hquzo@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 66',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sulfones fragmentation',
    rxnCode:
      'gC`iH`DRXzpGtd@!fHT`P eMFI@bMP~b@#qfQ qH Qm#!R_`CW_Xa}G[K| !RGQi| !R@Gx?_avz_@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 67',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sulfites fragmentation',
    rxnCode:
      'gJQiHl@aReVu@_QP!gCahHl@bNtA}E@ fHT`P#qbqh qbq qh#!Rmwsp_Gy?|Ot]lkp !RuwvH_Wx@G]k| !RG_i|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 68',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sulfides fragmentation',
    rxnCode:
      'eMB`HIchOh`!fHT`P eFB@HcA}D@#Q[ a` Q\\#!ROvL@Xqur_@ !RGYi| !R@FL]ngp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 61',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sulfides fragmentation',
    rxnCode:
      'gC`I@DBTij@~``!eFB`HIcA}F@ eF@HhP#qrL qq Qd#!RGtL@Pq}lG[I| !R_pp]Vop !R_pp]nop',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 62',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Simple inductive cleavage',
    rxnCode:
      'eM@bXzCKGgW@!fHT`P eF@HpP#Q[ a` Q\\#!R_qL@Dqwro@ !RGUi| !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Sigmatropic rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvB#Q^ Q[#!ROvL@XquJO@ !ROvL@Xqtzo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gJP@DkVhCzFHrEpBG`D@!eM@HvCzXcI\\@axA@ eF@HhP#qTqh Q^ qM#!ROvL@XpAl@FL]Bcp !R@FL?XqwZO@ !R@FL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.3',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-heteroene (Claisen rearrangement)',
    rxnCode: String.raw`daxH@JrRHiMUHAcEHHA@!daxH@NrSRHmUHAcGHHA@#IZaxla@ IhfP^c@#!Ru{vHo[x@u?sWoY_|e{t]Dop !R@BL?Xs|\[E|cWs}cOqp]vcp`,
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daxDBDqIRiubJ`CZN|bPtQqDD@cDD@chXO}c`!gJQ@DeNl`XqHHA@ eFH`fLGtYFDD@`#qqj\\x qqkx QX#!RbCtAHN\\}b@Kg@cx@yst]xop !R@DL?W@Al@DL]Nop !R@DL]agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGY@DDf]j`Odkl@!gCi@DDff@~`l eF@HhP#qrLk qrL qk#!RbOrH_Wx@b@JH_QuJ@` !RbOq~@Ha}GSjB !R@FL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daDLBHSdeJmVfZjh@~QHzHyBB@PbB@QrB@P!gCaAIiRmhCFQA@H@ gC``Eh{PGrTZHiHHAFPPB@#Ikb[HPP I`Tp qky#!R}{rpwKy?lGvpO[y?og|]dep !ROqp@[@@cGUk| !RbKwW_[x@G_k|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`MTj}jPOihbl``DUA@H@!eMHJMPqiA@H@ eMHFM`~fHr``D@#qStM qTX qNh#!RbKwWo[x@upKW_QtR?@ !R@Ox?oawZ_@ !R@BL?XqwzO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@DeZu@_PqFIA@HFB@!eMHJM`qiA@H@ eF@HhP#qeVH qbh qq#!RWrM@XpAl@BL]Bcp !ROvL@HqwZO@ !R@BL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJP@DkVhCzF@!eM@HvCzX@ eF@HhP#qbqh Qm qM#!ROvL@XpAl@FL]bcp !R@FL?XqwZO@ !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.3',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'daDD@DqJg^ffZh@qQDD@cDD@`!gGQ@BeJmJHGFEA@H@ eFHBJFLHHA@#IGmdehp IxakS IeP#!Rog?w_KC\\lCvp?[@|lOt]tkp !R|Gw~@OA|mpKp_QwZ`` !R@BL]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFp@DiTujhB!gC`@Die@` eF@HhP#q]aV q]a Q\\#!R_g~w_K_}mwvw_AuRO@ !R@Fp?[@AcGUk| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFx@@eJfuS@P!gC`@Die@` eF`BJD#q]aV qqU q\\#!R_g~w_K_}mwvw_AuRO@ !R@Fp?[@AcGUk| !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gOu@AReLm]SLAcB``D@!gJY@@TeVTCFEA@H@ eF`BJD#IKJRV` IZDrP qM#!R}xNp?[y?}{r~_{@}GQI\\ !R_vq?Dw}l_vp]z`H !R@BL]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode: String.raw`didDB@{iRYefxijh@zRhX!gNpaAQJRs\uBIzQg@ eF@HhP#IwlDdeZ IwlIEh IFP#!RbMvH?Cx_bMt~@Hc]Oa~H?AtJo@ !Rm{vwoSy?musPO[\}GYh\ !R@DL]Akp`,
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'fdeA`D@\\brTfYY_m]gIZ|DhJB@@h@@~aF@!didHB@BTfUvfZVV@OhB@ didD@@iIYgxUie`B#iup`jXdibCPcXKoI iSxKhvMHP IwbkEYH#!RbCvH?Ky_bCv~@H`}oe~H?Hc|oe~~@H`}esv~W{y_e{v~WquRs@ !RlKvpwKy?lKvpO[y?lKvpOQwZg@ !Rmwvw_[y?msrpo[^}mwvwOAuzG@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'deTDB@{iRYemnJXj`CiJaoQt@!gGPa@QJRmsPbX gC`@DiPDCteZ@#IaLJfxYT IaBxU IriX#!RbGvH?Gx?bGu~@Hb}_c~H?Gx?G[I\\ !RbGvH_X`B_`BH_Qtz_@ !R|Gq~_?C}GXX|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Remote Hydrogen rearrangment',
    rxnCode:
      'gC`AEJTu@P!fH@Oj@ eM@fXvB#qVa qH Q^#!R@Fq?[@@SG_HB !RGWi| !R@AM?DqtZO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'eM@HzCzhcO\\@axADQbU`!fH@OjHw\\@axADQbU` eF@HhP#Q[ Qp Qd#!ROvL@XqurO@ !RGUi| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 4.1. a',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'eM@HzCzhcW\\@axADQbU`!fH@Oj@ eF@HhXqw@H^@QDXeX#Q^ a` Qt#!R@FL?XqwrO@ !RGUi| !R_rp]ngp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.1. b',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Rearrangment d',
    rxnCode:
      'gOpAIJUKua@@Gtt@!gOpAMJUKua@@D#q]gJp q\\oQp#!Ro`BWoXb}e?rW?I^}GPhB !Resv~@H`}epJW@kx@GShB',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.comptc.2016.07.018',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Rearrangment a',
    rxnCode:
      'dnD@BLeJV|jfZih@`!gOpAGJTju`@@D#qTuYx qigSp#!RSF\\_iUMg_wy~_wy?G_I\\ !RgtXxCJvp_`Cbl@\\LG]kB',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.comptc.2016.07.018',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Radical resonance',
    rxnCode:
      'gCaA@IRVXROtD_u@`!gCa@@dkPGtD_uD`#qbq qbq#!R_`BH@ha}GXhB !R@FL@[@AcG[i|',
    ionization: 'esi',
    reaction: 'Reaction',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Radical resonance',
    rxnCode:
      'gCaA@IRVdCzCOzdP!gCaA@IRVXROtF_uL`#qbq qbq#!R@FL@[@AcGTj| !R_`BH?Ha}G[hB',
    ionization: 'esi',
    reaction: 'Reaction',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Radical H Rearrangment',
    rxnCode:
      'eM@jXzCzXcV\\@`DSc@jd!eM@jXzCFlxA@HgFATh#Qg Qg#!ROvL@XqtJO@ !ROvL@XqtzO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gGPiHaxJ\\ddKU@_QYFEF@P@!gC`iHaxJX{PGrDKHsHpB@ eF@HhP#qqZl qq] Qd#!R[C|?XpAlXp@@Xqvr_@ !Ruwu~@Ha}G]k| !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 41&42',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gGQiHlOASddeZhCyKM@!gCahHlOBNtA}aBcP eF@bXpP#qVLk qVa qk#!RPpAlGq}C@Fp@Pqvr_@ !RO^\\@OcvHG]i| !RY`@]^op',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 43',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gJQiHlOASGmPGrVZ@!gC`iHaxBX{PGtT@ fI@Gu`#qbqh qbM Qp#!Re{v~@Ky_bKt]Lgp !Re{v~@Hb}GYk| !RGWi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 44',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Phosphonates fragmentation',
    rxnCode:
      'gJQiHlOBSGmPGtd@!gCahHlOBOTA}I@ fHT`P#qbqh qbq qh#!Ruwu~@Gx?bGt]Lgp !Ruwu~@Ha}GUk| !RGWi|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 59',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode: String.raw`gNpYHlQxR\ddqZj@~Tap!gJPYHlQxRX}j@~TaP eF@HhP#qbuKx qbqh q{#!RXs|@Xs}l[@@@[@AcGPi| !Ruwu~@Gx?bGt]vgp !R@FL]Akp`,
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 37A&B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gGPYHlQxJTjmj`Ohh@!gCaiHlO@SGZ@` eFHBLGtP#IaLJa qbi IpP#!R[C|@[C}cXp@@Xqvr_@ !Ruwu~@Ha}GUk| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 38',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gGPYHlQxJTjmj`OlhtF@!gJPXHlQxQ{TA}eF`p fHT`P#qqU\\ qqUX a`#!R[C|@[C}cXp@@Xqvr_@ !Ruwu~@Gx?bGt]vgp !RG_i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 40',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Oxonium Resonance',
    rxnCode: 'eFH`fJGtQFDD@`!eFHhfLGuQFdD@`#QX Qd#!R@BL]bgp !R_vp]vop',
    ionization: 'esi',
    reaction: 'Reaction',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Oxime-ethers fragmentation',
    rxnCode:
      'gCiAHIJTt`_JPh@!eF``fJGtX eFHBJD#qbq qQ Ql#!R@Fp?[@AcGWK| !R@FL]Vgp !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 36',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode: 'eMH`eIXOh`!fH@Oj@ eFHbfJD#Qg Qp Qd#!R@Fp@Xqwr_@ !RGUi| !R@FL]^kp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode:
      'eMH`eIXOh`!fHT`P eMHAIXOj`#qNP QP qN@#!R@Fp@Xqwr_@ !RGQi| !R@Fp@Xquz?@',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 32',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBCDcAcBQFIdT!eFBcDIcA}EqaHcD@#QX QX#!R@FL]bgp !R@FL]vgp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF@HhP!eF@bXp_zi@#Qd Qd#!R@FL]Rkp !R@FL]vkp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Ionization',
    rxnCode:
      'gC`@DkZ@qds`D@`!fH@H eM@fXvCFlxA@H@#qbq qH Qg#!RWvp@[@@cGWHB !RGYi| !RWrL@HqvzO@',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF@H`Zp`!eF@bXp_U@#Qd QX#!R@FL]Rkp !R_rp]Vop',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Ionization',
    rxnCode: 'fI@FL``D@!fIRPLYA@HjP#a` a`#!RGPi| !RG]i|',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF@HpXp``D@!eF@bXpXt``D@#Qd QX#!R@FL]bgp !R_rp]Vop',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtP!gChaHDiRUhCzJ@#Qd QBP#!R@FL]Bgp !R@FL@[@AcGSj|',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Ionization',
    rxnCode: 'fI@FMg@HAG~U@!eFJhrJXpXug@HA@#a` aP#!RGXi| !R@FL]Nkp',
    ionization: 'esi',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'fI@FMg@HAG~U@!eFJhtJXpXug@HA@#a` aP#!RGXi| !R_rp]Vop',
    ionization: 'esi',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'fI@FMg@HAG~U@!fIRPOjHv\\@`D@#a` a`#!RG\\i| !RGUi|',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'fI@GuD[N@PBO|j!fIS`L[N@PB@#a` a`#!RGZi| !RGUi|',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'fI@FMg@HAG~U@!eMjrX@fezN`~SjHug@HA@#a` aP#!RGPi| !R_qL@DquZo@',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Inductive cleavages assisted by adjacent heteroatoms',
    rxnCode:
      'gCaALIRfhCJAxsEpBG`D@!eFH`fJFLEpBG`D@ eF@Hp_Q@#qbq qJ Ql#!R[pL@@v}lGSI| !R@@L]Vgp !R@@L]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'dayHBDxDeIYtjj@LhQHdU@!gCi@DDeZ@~b` gChA@IRVdCzB@#IyjH\\R@ IyjD qbq#!RtEsP_]A\\Og?P_]A\\tGt]|kp !R@DL@[@ACGSi| !R@DL@[@ACGXY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4',
    description: 'Fig 23 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'gJPAMJTmTAeLhHcBW@H^@QNRO@!gC`AMJUm@_SQFXn@P|@b\\d^ fH@H#quQ` quT qH#!R@Fq_[@@cWrL]Lgp !R@BM_Hu}lGUi| !RGPY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.4',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gChA@Icu@YPOYQ^`bNB\\GaHXECAjb@!fJ@FLgAx@ fHT`P#Q`P a` QP#!Rwg~PO[\\}G_H| !RGUi| !RGWi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eFH`fLFTOzLcBB@P!fI@GudYA@H@ fHT`P#Qd a` QP#!R@DL]\\gp !RG]i| !RGWi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eMhdYRRCJW}N@!fJ@D eFH`fND#Qg Qp Qd#!R@Fp@PquJ_@ !RGUi| !R@DL]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eMDaYRRCJW}LQeA@H@!fI@FL``D@ eFH`fND#Qg Qp Qd#!R@Fp@@qvJ_@ !RGUi| !R@@L]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ@!gC`HAxQz`H eM@fXvB eF@HhP#IaLJfxY qan IF^ qS#!R@FMl@C}lXs|@[@Ac@Fp@Xqvr_@ !Ruwu~@Ha}GYk| !ROvL@XquzO@ !R@FL]Qkp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGYALMJT}TpGRdX!gJY@DDefXB fHT`P#qnZa qnTH qX#!RbGwW_X`B_`BH_Qur?@ !RbGvH@gx@bGt]Nop !RG_i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gCaA@IRmhCzZHpHHA@!eFH`fJGtQFDD@` eF@HhP#qqT qq Qd#!RWvp@[@@cG_I| !R@BL]vgp !R@BL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGPiH`DZ\\ddJu@XsHp\\@!gC`iH`DBXzpD eF@HhXpcAp@#qVLk qVM qc#!R[C}c@@AlOvL@Xqvr_@ !Ruwu~@Ha}GYk| !R_rp]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1002/rcm.9131',
    section: 'conclusion',
    description: 'scheme 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eFH`fLG~hP!fI@G~i@ fHT`P#QX QP a`#!R_rp]\\gp !RGYi| !RGSi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eM@jXzCKGgW@!fHT`P eF@HhP#Q[ Qp Qd#!ROvL@Xqwro@ !RGUi| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gBPAML^Jj@sfb`!gC`AMJUm@YqQP#qVL qTN#!R@GxBu}\\BG_I| !ROvp@[@AcGSi|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eM@jXzCfh!fHT`P eF@HhP#Q[ Qp Qd#!RGtL@Pqwro@ !RGUi| !R@DL]^kp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: '',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eM@bXzCzhsT!fHT`P eF@HhP#Q^ a` Q\\#!R_qL@Dquro@ !RGYi| !R@AL]nkp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1093/chromsci/43.2.92',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gCaA@IRUhCzB@!eFHbfLGtP eF@HhP#qtQ Qx qQ#!R@FL@[@AcGPi| !R@FL]vkp !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode: 'eMH`eIhOhp!fH@H eFH`fJGtP#Qg Qp Qd#!R@Fp@XqtJ_@ !RGYi| !R@FL]ngp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gJQA@IRUZ`OhH@!eMH`eIdOhp eF@HhP#qTqh Q[ qM#!R@Fp@XpAl@FL]Bgp !R@Fp@Xqtz_@ !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gCaA@IRVhCzC@!eFH`fJGtP eF@HhP#qTq QX qq#!R@FL@[@AcGPi| !R@FL]vgp !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gJPaAaJTtlA@!eMHAITH eFH`fJGtP#qfUH qnH Qd#!Rb@KW@ha}_`@]lhH !R@Gx@_awZ_@ !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gJQAAIRgjPH!gJQA@IRgeaDp#qTnH qTnH#!ROvL@Xs}lOvL]\\kp !RbGwW_X`B_`@]nop',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gCaA@iRZhCzB@!fI@Gu` eM@fXvB#qJt qH Q[#!Ru?q~@M]}GSJB !RGUi| !ROvL@XquzO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode: 'eM@jXzB!fHT`P eF@HhP#Qg QP Qx#!R_qL@DqtJO@ !RGSi| !R@AL]fkp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode:
      'gJPAEJUkTA@!eM@bXvB eF@HhP#qVah Q[ qi#!R_qL@DpAl@AL]bcp !R_qL@Dqvz_@ !R@AL]Vkp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen rearrangment',
    rxnCode: 'eM@jXzCKGgW@!fHT`P eF@HhP#Q[ Qp Qd#!R_qL@Dqwro@ !RGUi| !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen lost',
    rxnCode: 'eM@jXzCVd@!eO@bXyjCVT@#Q[ Qg#!R_qL@DquJO@ !R?`Bw@auZ?@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Hydrogen elimination',
    rxnCode:
      'gFpACJTj[ATA}C`!gFpAAJTjZ@@A@#qbqk qn\\J#!Rog~wOK_}m{vwOAurO@ !Rog~wOK_}m{vwOAuZO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Halide Elimination',
    rxnCode:
      'eMBGDchOjbLiDX`!fHfHA}QFRHq@ eF@HhP#Q[ Qp Qd#!ROvL@DqurO@ !RGUi| !R@BL]^kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'H Radical Lost',
    rxnCode:
      'eF@bXp_QDXs`D@c~hP!fHd@AjP eF@bXhXqg@HA@#QX  QX#!R_rp]|gp !RGYi| !R_rp]ngp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNpaIYJU_MU@_JQXbh``DUA@H@!gCa@IGj@~dbLbB@P eMHjfM`~jHt``D@#qqWeX qqW qeX#!Ru{vHo[x@b@J~@Hb}GSK| !Ruwv~@Hb}GUi| !ROvL@HqwzO@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNxaLJIRU[jXCzZ@!eMH`eIxH eF`BJGtP eFHBND#q{iV` Qv qM q{#!R_c}~Oxa}b@I~@Ha}G]H\\ !R_wy?_awj_@ !R@FL]ngp !R@FL]Agp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gGPACJTkUPFtlUlxA@HlLG~r`!eN@HdH eF@HhXqg@HA@#qrLh qqh Qd#!R@FL?XpAlOvp@Xquro@ !RJW}yXQuZO@ !R@FL]Agp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.5',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'daF@B@BTeeVz`@@B!gOpAMJUKua@@D fJRPH#IGfbdK@ q\\oQp ID#!Rmwrw_Wy?mwrw_[_}mwp]Dcp !Ru{u~@Hb}upKW@gx@GUhB !RG_i|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'did@BLeJeWk``b@CzAbLMcApB@!gOpAMJUKua@@D eF@HhXqcApB@#IZJyBGI q\\oQp IFP#!Rquu^@Ha]q?sG?H`BW`BHWQur@` !Rquu^@Ha]q?sG?Ex@G]hB !R@Gt]Agp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'dif@B@BTeYWaz@@@OhB@!gOpAMJUKua@@D eF`BND#Id^ZJPl q\\oQp IdP#!R_`A~@M\\Bu{u~@M\\BupI~@AuRh` !Ru{u~@Hb}upKW@gx@GUhB !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'didHB@BTiyWaj@@@OhB@!gOpAMJUKua@@D eFHBLGtP#IGiZJPl q\\oQp IFP#!RuwvH_]_|uwu~@M_|u?q~@Awb@` !Ru{u~@Hb}upKW@gx@GUhB !R_rp]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'dmtDB@PIRY^UeVj@@@OhB@!gOpAMJUKua@@D gC``@deZ@`#IaLJfxYWP I[aJUt qbu#!R_`CW?Hc|uwvH_Xc|_c~H_Xb}_c|]LhH !Ruwu~@Ha}u?sW?Gx@GUhB !R@FL@[@AcGXY|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode: 'eMH`fN`~b@!fHT`P eFHBLGtP#Qg QP Ql#!ROvL@Xqur_@ !RGYi| !R@FL]ngp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 33',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'gCaA@IRfhCiQs{BIF`!eFH`fLGtX eF@HhP#qVa QX qN#!R@Fp?[@AcGPk| !R@FL]vgp !R@FL]~kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 34',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'eMH`fN`~RJ@!fH@Oj@ eFH`fJGtP#Q[ Qp QX#!ROvL@Xqvro@ !RGUi| !R@FL]ngp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 35',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ether/water elimination',
    rxnCode:
      'gCa@@eMPFtWihb```DJFCX`!fI@GuDYA@H@ eF@HhP#Qdp a` Q\\#!R@Fq?[@@SG_K| !RG]i| !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.3390%2Ftoxins6082580',
    section: '2.2',
    description: 'Fig. 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Ether/water elimination',
    rxnCode:
      'gCaAHiRfhCZ[tTQTPPBMCAlp!fI@GuDYA@H@ eF@bXhP#Q[@ a` Qt#!R_qL@Xs}lG[J| !RG]i| !R_qp]^op',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.3390%2Ftoxins6082580',
    section: '2.2',
    description: 'Fig. 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gC`a@aJRm@_PP!eMHAIhOh` eFH`fND#qbq qq@ Qd#!R@FL@[@AcG_I| !R@Fp@XqwZ_@ !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'http://dx.doi.org/10.1088/1468-6996/10/3/034602',
    section: 'Results',
    description: 'Fig. 5',
    kind: 'reaction',
    web: 'https://www.researchgate.net/figure/a-Chemical-structure-of-oxidative-reserpine-MW-6077-b-Post-source-decay_fig4_26637371',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHbeIXH eFHBLGtX#qrLh Qv qM#!R@W~GKVQuazH]Lep !R@W|LEQvZw@ !R_tP]^op',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC`a@eJSM@_QX eF@HhP#satpj satp qi#!RbOrHo[x@b@JHoQtJ`` !RbOrHo[x@GSjB !R_tp]~op',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 12',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC``@dfZ@~b` eF@bXpP#qbqk qbq qk#!RbOrHo[x@b@JHoQwr`` !RbOrHo[x@GSjB !R@BL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 13',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSJuPGtT@!gC``@deZ@` eF@bXpP#qbqk qbu qK#!Ro`BW?Hc|e{vHoQtr`` !R@BL@[@@cGSi| !R_tp]^gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 14',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHAITH eFH`fLGtX#qbqh qbH qu#!R|Gwp_Gy?|Gt]|cp !R_wy?_atZ_@ !R@FL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 15',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Elimination (missing source)',
    rxnCode: 'eM`AIhOdq`!fJ@Gup eF@HhP#Qv Qp Qd#!R_rq?Dqvr_@ !RG]i| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'To check',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Elimination',
    rxnCode: 'eMHAIhOdm`!fI@Guh eF@HhP#Qg a` Qt#!R@Fp@HqvJ_@ !RG]i| !R@BL]^kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Elimination',
    rxnCode:
      'gC`@Dij@~b`!eF@Hp_Q@ eF@HhP#qVa qq Qd#!R@Fp?[@AcG_HB !R@FL]vgp !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.jpha.2016.04.008',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Electron Sharing',
    rxnCode:
      'gCaAAIRVdCzB@!gCaA@IRUdCzB@#qbq qbq#!R@FL@[@AcGTj| !R@FL@[@AcG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJPaAaJTkTHGyZCDTDD@cHHA@!eMDiicXOfabKHHAB``D@ eF@HhP#qbqh qTH qu#!RepJH@kx@bKt]LhH !ROvL@HqwZO@ !R@BL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@IRmhCzB@!eF``fJGtX eF@HhP#qTq QX qq#!ROvp@[@AcG_I| !R@FL]Vgp !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJXA@IRmZ`OdHL@!eM`bfN`~b@ eF@HhP#qTqh Q^ qi#!ROvL@XpAl@FL]Bkp !ROvL@XqwZo@ !R@FL]Akp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@Icu@_PP!fH@H eM``fM`~b@#qTq qH Q[#!Ruwu~@Ha}GWK| !RGYi| !ROvL@Xqvz_@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    software: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gJPlLPDSpPPdtu@_QP fHT`P#qbqk qbqh qX#!RXp@@[C}cXp@@XqvrP` !RbOq~@Gx?bGt]v`H !RGWi|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 52',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gC`eE`DSpdiLtA@ eFB@HcA}D@#qbqk qbM qs#!RXp@@[C}cXp@@XqtrP` !RbOq~@Ha}G]jB !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 53',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gJPmLPDSpPQIRZV`H fH@Oj@#q`qk qpeH qX#!RXp@@[C}cXp@@XqtrP` !RbOq~@Gx?bGt]v`H !RG_i|',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 54',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Displacement reaction ',
    rxnCode:
      'gCaALiRfhCJIxsHHADxH\\!fH@H eOH`fNZ`qaA@HgLN#qbq Qp qJ`#!R@Fq_[@@cG_K| !RGUi| !Rog~w?Quzo@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.3 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Displacement reaction ',
    rxnCode:
      'gJXA@YRgj`LhWmEFJFB\\TOlP!fH@H eO`BNZ`sfG@#qJDp Qp qJ`#!RWrL@Hu}lWrL]lkp !RG]i| !Rog~w?QuzO@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.3 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Displacement reaction ',
    rxnCode:
      'gJPACJUkTAeB|YBXN@PBIqQx!gBPAML^Jj@qfI`xA@HgMG` fH@H#qTnH qVl qH#!RWrL@HpAl@BL]|cp !R@K{|ey\\BG]i| !RG_i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.3 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJXA@IRUjPH!eM@fXvB eF`BLGtP#qlVH qrH ql#!R@Fp@XpAl@FL]Bgp !ROvL@XqwZO@ !R@FL]~gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJQABYRmZ`LXTD@`!eM@fXvB eFH`fLGtQFDD@`#qMr` qNh Qd#!R@BL?Xs|\\OvL]xcp !RWrL@HquZO@ !R@BL]~gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'gGYADEJSLuPGtT_nlK|!gChA@Icu@_PP eFHBND#qtSi qQ] Qx#!RbGvH@gx?_`BH_QtJo@ !Ruwu~@Ha}GUk| !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7.1.3',
    description: 'Fig. 22 c. ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Dioxolane fragmentation',
    rxnCode:
      'dclDB@iYRfUw\\kahHBj@CzI`!eFHBJD deTHB@RTfU]ih@I`Hz~`H@#IzAQirbWS IdP IzD[JI]L#!RIm~?ck^}|KuMswy?_g?po_B}|GspoQwR{@ !R@FL]fgp !RbOq~@Ha}b@JH@ha}bGvH?Ha}GXZB',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1002/jms.1963',
    section: '',
    description: 'Fig. 4',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Dioxolane fragmentation',
    rxnCode:
      'detDB@jYRfUwJxZB@h@H!eFHBJD daDHB@RTfUVyiZPB#IaLJfxYT Ql IXdziEP#!RIm~?ck^}|KuMswy?_g?po_B}GSKl !R@FL]fgp !RBGvh[AF?HBVDj?Jo@MX]Aep',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C3AY40543E',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'DB rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvCzX@#Q[ Q^#!ROvL@XqvJO@ !R@FL?XqtzO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.jpha.2016.04.008',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFp@DiTvjhB!eF@HhP eF@HhP eF@HhP#qbqk qn qY Qd#!R_g~w_K_}mwvw_AvRO@ !R@FL]Fkp !R@FL]Nkp !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.7',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Cyclization',
    rxnCode: 'eM@jXzCNhh!eO@bXyjCNXh#Q[ Qg#!R_qL@DquJO@ !R?g~w?QuZo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Charge Stabilization',
    rxnCode:
      'gCaAAIRVdCzB@!gCaAAiRVXROtD@#qbq qbq#!R@AL@[@@SGRj| !R?`BH@hc}GShB',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Charge Remote Fragmentation',
    rxnCode:
      'gC`@Dij@~RcP!eF@HhP eF@HhP#qqb Ql qJ#!R@Fp?[@AcGXk| !R@FL]vkp !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.5',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gJXaLDiRYZ`Ohh@!eMhdiRVB eFHBLGtP#qbqh qbH qu#!R|Owp_Gy?|Gt]|mp !R@Fp@XqwZ?@ !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 16A & B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gJXaLDiRYZ`Ohh@!eMhDRUB eFH`fLGtX#qbqh qbH qu#!R|Gwp_Gy?|Gt]|mp !R_wy?_atZ_@ !R@FL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 17',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gGXaLDiRYvj@~b`!gChaLDiRYhCzK@ eF@HhP#IaLJa qbq IF`#!Rwg~Pw[_]dArP_Qwrw@ !RdKw^_yA\\GSk\\ !R_wP]^op',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 18',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'COOH loss',
    rxnCode:
      'gOxaBDYR[fmjj@pb}C@!gBXA@IReYj@` eMDARVCzX@#qbqkx qi{ Qg#!RbOp~@H`}HMkZK}hoGPhB !RO`@@O`@~GUhB !R_pq?Dqvz?@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1038/s41598-019-42777-8',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'CO loss',
    rxnCode:
      'gOxaBDYR[fmjj@pb}C@!gJYABCJRkTA}C@ eFHPfzND#qbqkx qq_h Qd#!RypKgOSx@iJSKiLndG^KB !R_pq?Dw|L_qL]zop !R_pp]~op',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1038/s41598-019-42777-8',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'CO elimination',
    rxnCode:
      'gCa@@dsPFRTZ@!eFHPfzND eF@HpYIE@#qJf qJ Ql#!RbOq~@Ha}G_JB !R@FL]Vkp !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.8',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    software: '',
  },
  {
    label: 'CO elimination',
    rxnCode:
      'gOq@@drm[UTA@!gKP@Di\\Zj@` eFHBND#qbqkx qY~h Qd#!RbOvH?Oy?bOvH__y?GPi\\ !R?g|_Fa}eTv\\]fcp !R@AL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.8',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'CO Elimination',
    rxnCode:
      'gCaA@IRWhCZZLtLG~s@!fHT`P eFHPfzND#Qg@ Qp Qd#!R_g}~_?A}G_H\\ !RGYi| !R@FL]nkp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Beta Remote Hydrogen rearrangment ',
    rxnCode:
      'gGPACJTkUPD!gJPACJUkTA@ fH@Oj@#qrLk qTqh qX#!R@AM?DpAl_vp@Dqtr_@ !R_qL@DpAl@AL]~cp !RGYi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: 'Mass-Frontier',
  },
  {
    label: 'Aromatic elimination',
    rxnCode:
      'ded@@DiUUeiZ@hTZfh!gFp@DiTt@@B gC`@DiZDC@#IpdjFGiT qcUq IGiT#!RbGvw_X`B?g?~@K]}b@K~_?x@GWJ| !R?g~w@k_}m?vw@avZO@ !Rb@K~_xc}GPZ|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.6',
    description: 'Fig. 16',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'gGXiMDOCSddajXCFEA@H@!gC`iHaxBX}HFLrB@P eF`BLD#qbqk qbu qK#!RXp@?XpAl[C|@Xqvr_@ !Ruwu~@Ha}GUk| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 55',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'dazDbLa@|LeJi~ij@OdrNbLD``D@!gC`hHaxQvPOhHcL``D@ eF``fLGtX eF@HxP#IaLJnXP qbu qK IxP#!R@FMc@C}c[@@@[C}l@FL]top !Ruwu~@Ha}GUk| !R@FL]~gp !R@FL]Qkp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 56',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'gNxiMDOCSddauSPGrtNHphHA@!gJXiMDOCSGuHGtvQaPPB@ eF@HhP#qbqkx qbqh q_#!R[@@?[@AcXs|@[@AcG_I| !Ruwu~@Gx?bGt]Ngp !R@FL]Akp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 57',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gGXiMD@cSddaVhCz[@!gC`iH`DBXzpD eF`BLGtX#qqj\\ qqk QX#!R[@ACGq}l@DL_PqwR_@ !RysvHOSx@GYk| !R_pp]^op',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 63',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gGXiMD@cSddaVhCy[C@!gC`hH`DQuPH eF``fLGt\\#qbqk qbu qK#!R[C}c@@AlOvL@Xqvr_@ !Ruwu~@Ha}GYk| !R@FL]^gp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 64',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminodithiophosphate fragmentation',
    rxnCode:
      'gGYMC`DSphPIRfji@~`bLjB@P!gCiEEAxXHDqzPLYdD@` eFB@HcA}D@#qrYl qQl qs#!ROvL@Xs}cXpAlOqwRO@ !R_`BH_]]}GUk| !R@FL]~gp',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 58',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gChA@IRfhB!eF`BLD eF@bXpP#qLZ qK Qd#!RpDp^_|B]GPj| !R@Kt]Vgp !R_qP]nop',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gChA@IRfhCyBM@!eF``fLGtX eF@HhP#qbq Ql qQ#!R@Fp?[@AcGPi| !R@FL]vgp !R@FL]~kp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 4 ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gJXA@IRij`OhH@!gChA@Icm@P fH@Oj@#qrM` qri a`#!Ruwu~@Ha}upH]Lop !Ruwu~@Ha}GUk| !RGWi|',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 5',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gGYADEJSNuPD!gCiADEJSM@_QP eF@HhP#qbq_ qbq q{#!RbOrH_Wx@b@JH_QvJ@` !RbOq~@Ha}GSjB !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gJYADEJSKTAkLh!eMHbeIXH eF`BLFlJ@#qbqh qbH qu#!RxCw`[Ey?xEt]Bcp !R@Fp@?QwZ?@ !R@Gt]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 6',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gJYADEJSKTAkLh!eMHAITH eF``fLGtQVE@#qbqh qbH qu#!R|Gwp_Gy?|Gt]|cp !R_wy?_atZ_@ !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gCiADEJSM@P!fHT`P eMhDRVB#qbq qH Qg#!RbOq~@Ha}G_JB !RGQi| !R@Fp@Xquz_@',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 8',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gJYADEJSKTA@!gCi@DDfZ@` fHT`P#qbsH qbs qH#!R|Owp_Gy?|Gt]Bcp !RbOq~@Ha}G]jB !RGWi|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 9',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTfUfjX@~QLr@!gJU@E`dru@_SX eMHbeIXH#IZbyAr@ IZnHP Qv#!Ro`BW?Hc|e{vHo[y_e?p]ThH !Ro`BH?I_|bKt]vhH !R_tq?Dqwz?@',
    ionization: 'esi,ei',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 28',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'gGTaEaUJSNuHGrVZ@!eMhdYRVCz^@ eMhDRUB#qyuS qZp qyh#!RbOrH_Wx@b@JH_Qur`` !R@Fp@XqwZ_@ !R_wy?_auz_@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 29',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTf[VjX@~QHr@!gGTaEaUJSNuHGrVZ@ eF@HhP#IaLJfEP IaLJa IU`#!Rb@JH_Wx@_c~H@m]}bGt]|gp !RbOrH_Wx@b@JH_Qvz`` !R@FL]Akp',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 30',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
  {
    label: '1,5-shift',
    rxnCode:
      'gJP@DiYXRWtL@!gJP@DiYXRWtL@#qbqh qfUH#!ROvp@[C}c@FL]Bop !R@Fp?[@AcOvL]nop',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.7',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gC`@Dij@~RcP!eF@HhP eF@HhP#qVa Qd qq#!R@Fp?[@AcGXk| !R@FL]vkp !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gC``Adej@~PcP!eFHBJD eFHBJD#qtQ qJ Qx#!R@FL@[@AcGTj| !R@FL]vgp !R@FL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gCa@@dmPGrDZ@!eFHBJD eF@HhP#qNT qN Qd#!R_rq?Dw|lGSK| !R@FL]vgp !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: '1,3-shift',
    rxnCode:
      'gJP@DiYXRWtL@!gJP@DkVdCzJ@#qqU` qTqh#!R@Fp?[@AcOvL]\\op !ROvL@XpAl@FL]ncp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.7',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: '1,3-elimination',
    rxnCode:
      'gCa@@dmPGrDZ@!eFHBJD eF@HhP#qTq QX qq#!R@FL@[@AcGTj| !R@FL]vgp !R@FL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive,negative',
    isbn: '',
    software: '',
  },
  {
    label: 'α-Elimination',
    rxnCode:
      'eM@ghzCFZXN@P|@`!fHW@P eF@HhXqSApBG`D@#Q^ Qp Qd#!R_qL@DqwrO@ !RG[i| !R@AL]Vgp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7.1.4',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    software: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'dcMDbLvD@Hr\\ddJfRtjmP@P@_If[@!eF``fLGt\\ deVD`Ia@BLdabRwBkRs@D#IaLJf{QVS qK IaLkmEYL#!R@m]}ux`BupJH_]]}_`CW?M\\B_`CW?Avb`` !R@FL]fgp !Ruwu~@Ha}bOq~Oxa}bKu~Oxa}GXX|',
    ionization: 'esi,ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 64',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    software: '',
  },
];
